/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskNavigationResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { knowledgeHubArticleInCategoryRoute } from '@jira/router-routes__servicedesk-knowledge-hub-routes/src/knowledgeHubArticleInCategoryRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { APP_NAMES, toPackageName } from '@jira/servicedesk__common/src/toPackageName.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { getKnowledgeHubResources } from './common/getKnowledgeHubResources.tsx';
import ServiceDeskKnowledgeHubViewArticle, {
	LazyServicedeskKnowledgeHubViewArticle,
} from './ui/view-article/index.tsx';

export const knowledgeHubArticleInCategoryRouteEntry: Route = createEntry(
	knowledgeHubArticleInCategoryRoute,
	() => ({
		group: 'servicedesk',
		perfMetricKey: 'service-management.knowledge.article',
		// eslint-disable-next-line no-restricted-syntax
		component: ServiceDeskKnowledgeHubViewArticle,
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
		},

		resources: [
			...getServiceDeskNavigationResources(),
			...getKnowledgeHubResources(),
			getConsolidationStateResource(),
		],

		forPaint: [LazyAtlassianNavigation, LazyServicedeskKnowledgeHubViewArticle],

		meta: {
			reporting: {
				id: APP_NAMES.KB_VIEW_ARTICLE,
				packageName: toPackageName(APP_NAMES.KB_VIEW_ARTICLE),
				teamName: 'jsm-nebula',
			},
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
